import { createContext } from "react";

export const TermsContext = createContext({});
